import React from 'react';
import {withTheme} from '@rneui/themed';

import TextInput, {type TextInputProps} from '../ui-controls/form/TextInput';

type ThemedTextInputProps = TextInputProps & {largeText?: boolean};

export default withTheme<ThemedTextInputProps>(
  TextInput as React.ComponentType<ThemedTextInputProps>,
  'TextInput',
) as React.FC<ThemedTextInputProps>;

declare module '@rneui/themed' {
  export interface ComponentTheme {
    TextInput: Partial<ThemedTextInputProps>;
  }
}
